import { useMutation, useQuery, useQueryClient } from 'react-query';
import { chamarOktonBank, enviarOktonBank } from '../oktonbank';

// Saque: dinheiro que sai da Conta Bancária e entra no Caixa. O IFLEX guarda a
// Moeda da Conta em moedabanco_saq; a tela trabalha com a Conta.
export interface Saque {
  id_saq: string;
  data_saq: string;
  valor_saq: string;
  observacao_saq: string | null;
  moedabanco_saq: string;
  // Nome da Moeda do banco: é ela que diz por onde o dinheiro saiu.
  nomemoedabanco_saq: string | null;
  caixa_saq: string | null;
  planocontas_saq: string | null;
  id_cts: string | null;
  descricao_cts: string | null;
  nome_pct: string | null;
  // Saque não tem coluna de conciliado: quem registra é a conciliacaobancaria,
  // e o back devolve a contagem de vínculos.
  conciliado_saq: string;
}

export interface NovoSaque {
  conta?: string;
  data?: string;
  valor?: string;
  observacao?: string;
  planocontas?: string;
  // Em branco o IFLEX resolve pelo Caixa aberto, como sempre fez.
  caixa?: string;
  // Partindo da Conciliação: o lançamento dá Conta, valor e data, e o
  // Saque já nasce conciliado.
  extrato?: string;
}

interface IResponseData {
  rows: Saque[];
}

export type StatusConciliacao = 'all' | 'pending' | 'reconciled';

export function useSaques(
  idConta?: string,
  dataIni = '',
  dataFim = '',
  status: StatusConciliacao = 'all',
  habilitado = true,
) {
  return useQuery(
    ['saques', idConta ?? '', dataIni, dataFim, status],
    async () => {
      const dados = await chamarOktonBank<IResponseData>('OBSaque', 'listar', {
        conta: idConta || '',
        dataini: dataIni,
        datafim: dataFim,
        status,
      });
      return Array.isArray(dados?.rows) ? dados.rows : [];
    },
    { enabled: habilitado },
  );
}

function invalidar(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries('saques');
  queryClient.invalidateQueries('monitor-bancario-resumo');
  queryClient.invalidateQueries('conciliacoes');
  queryClient.invalidateQueries('dashboard');
}

export function useCreateSaque() {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: NovoSaque) =>
      enviarOktonBank<{ id_saq: number }>('OBSaque', 'cadastrar', {
        ...payload,
      }),
    { onSuccess: () => invalidar(queryClient) },
  );
}

export function useDeleteSaque() {
  const queryClient = useQueryClient();

  return useMutation(
    (id: string) => enviarOktonBank('OBSaque', 'excluir', { saque: id }),
    { onSuccess: () => invalidar(queryClient) },
  );
}
